if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('form', 'product-form');
      formData.append('sections_url', window.location.pathname);

      if(formData.get('product_complementary_modal_url') != null) {
        // Remove old complementary modal if exists
        if(document.getElementById('QuickAdd-Complementary') != null) document.getElementById('QuickAdd-Complementary').remove();

        // Open modal with its content
        const productElm = document.querySelector('.product');
        const productModal = formData.get('product_complementary_modal_url');
        const currentUrl = new URL(window.location.href);
        const variantId = currentUrl.searchParams.get('variant') ?? '';

        return fetch(productModal)
        .then((res) => res.text())
        .then((res) => {
          const text = res;
          const parser = new DOMParser();
          const htmlDocument = parser.parseFromString(text, 'text/html');
          htmlDocument.querySelectorAll('[name="quantity"]').forEach((quantity) => {
            quantity.value = document.querySelector('quantity-input .quantity__input').value;
          });
          if(variantId != '') {
            htmlDocument.querySelectorAll('[name="id"]').forEach((idInput) => {
              idInput.value = variantId;
            });
          }
          const productCard = htmlDocument.documentElement.querySelector('body').firstChild;
          productElm.insertAdjacentElement('afterend', productCard);
        })
        .catch((err) => console.error(`Failed to load content for handle: ${handle}`, err));
      }

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      if(formData.getAll('bundles[]').length > 0) {
        config.body = Object.fromEntries(formData);
        config.body['items'] = [];
        
        formData.getAll('bundles[]').forEach((bundle) => {
          const productAndDockeyData = atob(bundle).split('||dockeys=');
          const productData = JSON.parse(productAndDockeyData[0]);
          var properties = {
            '_bundleParentId': formData.get('id')
          };

          if(typeof productAndDockeyData[1] !== 'undefined') {
            if(getCookie('dockey')) {
              const dockeyValues = productAndDockeyData[1].split(',');
    
              if(dockeyValues.includes(getCookie('dockey'))) {
                properties.dockey = getCookie('dockey');
              }
            }
          }
          
          config.body['items'].push({
            'id': productData.id,
            'quantity': formData.get('quantity'),
            'properties': properties
          });
        });

        config.body = JSON.stringify(config.body);
      } else {
        delete config.headers['Content-Type'];
        config.body = formData;
      }

      if(formData.get('properties[_supportedDockeys]')) {
        if(getCookie('dockey')) {
          const dockeyValues = formData.get('properties[_supportedDockeys]').split(',');

          if(dockeyValues.includes(getCookie('dockey'))) {
            formData.set('properties[dockey]', getCookie('dockey'));
          }
        }
      }

      if (formData.get("increment")) {
        formData.set("quantity", formData.get("increment"));
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal && !formData.get('change_label')) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cartNotification.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cartNotification.renderContents(response);
          }

          if(formData.get('change_label')) {
            this.submitButton.setAttribute('disabled', 'true');
            this.submitButton.innerHTML = formData.get('change_label');
          }

          if(document.getElementById('free-shipping-bar') != null) {
            const freeShippingBar = new Fsb();
            freeShippingBar.updateAjax();
          }

          // Refresh product form
          if(formData.get('update_form') != null) {
            fetch(window.location.href)
            .then((res) => res.text())
            .then((res) => {
              const text = res;
              const parser = new DOMParser();
              const htmlDocument = parser.parseFromString(text, 'text/html');
              const productFormElm = document.getElementById('product-form');
              const productFormUpdated = htmlDocument.documentElement.querySelector('#product-form');
              productFormElm.replaceChildren(productFormUpdated);
            })
            .catch((err) => console.error(`Failed to load content for handle: ${window.location.href}`, err));
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
  const quantityInput = document.querySelector(".quantity__input");

  if(quantityInput != null) {

  }
  const minValue = Number(quantityInput.getAttribute("min"));
  const event = new Event("change");

  quantityInput.addEventListener("focusout", function () {
    const quantity = Number(this.value);

    if (quantity < minValue) {
      this.value = minValue;
      quantityInput.dispatchEvent(event);

      return;
    } 
    else if (quantity % minValue !== 0) {
      this.value = quantity - (quantity % minValue);
      quantityInput.dispatchEvent(event);
      
      return;
    }
  });
  quantityInput.dispatchEvent(event)
}
